import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from "prop-types";
import { FiCalendar } from "react-icons/fi";

const DatePicker = ({ ...props }) => {
    return (
        <ReactDatePicker
            locale="es"
            dateFormat="dd/MM/yyyy"
            calendarStartDay={1} // Monday
            {...props}
        />
    );
};

DatePicker.propTypes = {
    // Allow passing any props that react-datepicker accepts
    ...ReactDatePicker.propTypes,
};

export default DatePicker;
